export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false
};
export const PageName = '活动奖励配置(红利领取)';